import { useQuery } from '../../../ReactQuery';
import { get } from '../../../redux/api';
import type { GetToolsParams, Scope, ToolsResponse } from '../../../../shared/techStack';

/**
 * Get the aggregated tools for all projects within the organization.
 */
function getOrgTools(params: GetToolsParams) {
  return get<ToolsResponse>('/api/tools', true, params);
}

/**
 * Get the tools for a specific project.
 *
 * NOTE: This endpoint is not currently implemented in the backend.
 */
function getProjectTools(locator: string, params: GetToolsParams) {
  return get<ToolsResponse>(`/api/projects/${locator}/tools`, true, params);
}

/**
 * Get the tools based on the provided scope.
 */
function getTools(scope: Scope, params: GetToolsParams) {
  if (scope.scope === 'org') {
    return getOrgTools(params);
  }

  return getProjectTools(scope.locator, params);
}

/**
 * Get the query key for the tools based on the provided scope.
 */
function getQueryKey(scope: Scope, params: GetToolsParams) {
  if (scope.scope === 'org') {
    return ['tools', 'org', params];
  }

  return ['tools', 'project', scope.locator, params];
}

/**
 * Hook for fetching the tools for a given scope.
 */
export default function useTools(scope: Scope, params: GetToolsParams) {
  return useQuery<ToolsResponse>({
    queryFn: () => getTools(scope, params),
    queryKey: getQueryKey(scope, params),
  });
}
